import moment from "moment";
import {PuiChip} from "@portnet/ui";
import {getChipColorByEtatCode} from "../../../packages/detailPackage/data/colors";
import {formatPrices} from "../../../../common/utils/helpers";

export const consultationSouscriptionTableColumns = [
  {
    field: "operateur",
    headerName: "Opérateur",
    flex: 3,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) =>
      row?.autoritePortuaire
        ? "Port de " + row?.autoritePortuaire?.description
        : row?.libelleOperateur,
  },

  {
    field: "identifiant",
    headerName: "Identifiant",
    flex: 1.5,
    sortable: true,
    editable: false,
    valueGetter: ({ row }) => row?.identifiantSouscription ?? "-",
  },
  {
    field: "code",
    headerName: "Code Package",
    flex: 1.5,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row?.tarificationPackage?.code ?? "-",
  },
  {
    field: "tarif",
    headerName: "Tarif(MAD)",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.tarificationPackage ?  formatPrices( row.tarificationPackage.fraisService):"-"
  },
  {
    field: "autorise",
    headerName: "Autorisé",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) =>
        row?.tarificationPackage?.typeTransactionAutorisee?.description === "Illimité"
            ? "Illimité"
            : row.tarificationPackage?.nbrTransaction?.toString() ?? "-",
  },
  {
    field: "consomme",
    headerName: "Consommé",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row?.tarificationSummary?.consomme ?? "-",
  },
  {
    field: "restant",
    headerName: "Restant",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row?.tarificationSummary?.restantLibelle ?? "-",
  },
  {
    field: "debut",
    headerName: "Début",
    flex: 1,
    sortable: true,
    editable: false,
    valueGetter: ({ row }) =>
      moment(new Date(row?.validiteDu)).format("DD/MM/yyyy ") ?? "-",
  },
  {
    field: "fin",
    headerName: "Fin",
    flex: 1,
    sortable: true,
    editable: false,
    valueGetter: ({ row }) =>
      moment(new Date(row?.validiteAu)).format("DD/MM/yyyy ") ?? "-",
  },
  {
    field: "statut",
    headerName: "Statut",
    flex: 2,
    renderCell: ({ row }) => (
        <PuiChip
            color={getChipColorByEtatCode(row.statusSouscription.code)}
            fullWidth
        >
          {row.statutLibelle ?? "-"}
        </PuiChip>
    ),
  },
];
